import { useCallback, useEffect, useMemo, useState } from 'react';
export function useScrollPagination({ getPaginationItems, items: itemsProp, target = null, lastCardRef, }) {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [allLoaded, setAllLoaded] = useState(false);
    const [loadedItems, setLoadedItems] = useState(20);
    useEffect(() => {
        setItems([...itemsProp]);
    }, [itemsProp]);
    const loadMoreCards = useCallback(() => {
        if (allLoaded)
            return;
        if (!getPaginationItems) {
            if (loadedItems >= items.length) {
                setAllLoaded(true);
            }
            setLoadedItems((previous) => previous + 20);
        }
        else {
            getPaginationItems(page + 1).then((response) => {
                if (response.isLoadedAll) {
                    setAllLoaded(true);
                }
                setItems((previous) => [...previous, ...response.items]);
                setLoadedItems((previous) => previous + response.items.length);
                setPage((previous) => previous + 1);
            });
        }
    }, [allLoaded, getPaginationItems, items.length, loadedItems, page]);
    const displayItems = useMemo(() => {
        return items.slice(0, loadedItems);
    }, [items, loadedItems]);
    useEffect(() => {
        if (!lastCardRef.current)
            return;
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                loadMoreCards();
            }
        }, 
        //
        {
            root: target,
            threshold: 0,
        });
        observer.observe(lastCardRef.current);
        return () => observer.disconnect();
    }, [loadMoreCards, lastCardRef, displayItems, target]);
    return {
        displayItems,
        allLoaded,
    };
}
//# sourceMappingURL=useScrollPagination.js.map